export const COMPANY_ANALYTICS = "company-analytics";
export const COMPANY_ANALYTICS_JOURNEY = "company-analytics-journey";
